import { render } from "./HomePageView.vue?vue&type=template&id=8d34b198&scoped=true"
import script from "./HomePageView.vue?vue&type=script&lang=js"
export * from "./HomePageView.vue?vue&type=script&lang=js"

import "./HomePageView.vue?vue&type=style&index=0&id=8d34b198&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d34b198"]])

export default __exports__